//let server = "https://infinity.leonisa.com/webstore-service-embajadoras";
let fieldsIds = [];

window.addEventListener('load', function () {
  RenderAdditionals();

  $("#btn_active").click(function(e){
    if($("#checkTerms").is(":checked")){
      $("#btn_active").addClass("btn--loading");

      Activate();
    }
  });
});

document.addEventListener('variant:change', function(evt) {
  let variant =  evt.detail.variant;

  // se debe validar para no procesar cuando el inventario está agotado ya que viene sin variant
  if(variant != null){
    $("#current_variant_id").val(variant.id);
  }
  
  RenderAdditionals();
});

function RenderAdditionals(){
  let html = "";
  let currentVariantId = $("#current_variant_id").val();
  let inputTemplate = '<label for="##ID##" style="margin-top: 10px;">##NAME##</label><input type="text" id="##ID##" class="input-full" autocorrect="off" autocapitalize="off" autofocus="">';
  let selectTemplate = '<label for="##ID##" style="margin-top: 10px;">##NAME##</label><select  id="##ID##" class="input-full" autocorrect="off" autocapitalize="off" autofocus="">##OPTIONS##</select>';

  fieldsIds = [];

  if(currentVariantId != null){
    let additionalFields = $("#additional_fields_" + currentVariantId).val();
    let fields = additionalFields.split("|");

    for(let i in fields){
      let field =  fields[i];

      if(field != ""){
        let parts = field.split(":");
        let id = parts[0].toLowerCase().trim();
        let lname = id.replaceAll("_", " ");

        id = id.replaceAll(/[^a-z0-9\s]/gi, '').replaceAll(" ", "_");

        fieldsIds.push(id);

        if(parts.length == 1){
          html+= inputTemplate.replaceAll("##ID##", id).replaceAll("##NAME##", parts[0]);
        }
        else if(parts.length == 2){
          let temp  =selectTemplate.replaceAll("##ID##", id).replaceAll("##NAME##", lname);
          let optionsText ="";
          let options = parts[1].split(",");

          for(let j in  options){
            let option = options[j].trim();
            let sku =  option.split("*");
            let text = sku[0];
            let value = sku[1];

            if(option != null && option != "" ){
              optionsText+= "<option value= " + value +">"+ text+"</option>";
            }
          }

          if(optionsText != null && optionsText != ""){
            temp = temp.replaceAll("##OPTIONS##", optionsText);
            html+= temp;
          }
        }
      }    
    }
  }

  if(html != ""){
    html = '<div class="custom-label"><span class="hide-sticky">Additional Info</span></div>' + html
  }

  $("#additionals_content").html(html);
}

async function Activate(){
  let attributes = [];
  let variantId =$("#current_variant_id").val();
  let customerId =$("#customer_id").val();
  let referido_por_id = getCookie("referido_por_id");
  let referido_por = getCookie("referido_por");

  if(referido_por != null){
    attributes.push({
      name : "IsMLM",
      value : "true"
    });
    attributes.push({
      name : "fue_referido_por",
      value : referido_por
    });
    attributes.push({
      name : "fue_referido_por_id",
      value : referido_por_id
    });
  }

  attributes.push({
    name : "IsLevel",
    value : "true"
  });
  attributes.push({
    name : "mantener_nivel",
    value : $("#mantener_nivel_"+variantId).val()
  });
  attributes.push({
    name : "nombre_nivel",
    value : $("#nombre_nivel_"+variantId).val()
  });
  attributes.push({
    name : "nivel",
    value : $("#nivel_"+variantId).val()
  });
  attributes.push({
    name : "rango_min",
    value : $("#rango_min_"+variantId).val()
  });
  attributes.push({
    name : "descuento_nivel",
    value : $("#descuento_nivel_"+variantId).val()
  });

  //Attributo Origen EMBAJADOR
  attributes.push({
    name : "Origen",
    value : "EMBAJADOR"
  });

  for(i in  fieldsIds){
    let id = fieldsIds[i];
    let value = $("#"+id).val();

    if(value != null && value.length > 0){
      attributes.push({
        name : id,
        value : value
      });
    }
    else{
      alert("Campos sin diligenciar o con errores.");

      return;
    }
  }

  let wr ={
    shopId : Shopify.shop,
    customerId : customerId,
    variantId :  variantId,   
    attributes: attributes
  };

    console.log(wr);
    console.log(server);
    console.log(JSON.stringify(wr));
    await addAttriCart(attributes);
  
  $.ajax({
    url: server + "/api/Order/NewLevel",
    type: "POST",
    data: JSON.stringify(wr),
    contentType: "application/json;charset=utf-8",
    success: function (url) {
      if (url != null ) {
        console.log(url);

        window.location.href = url ;
      }
      else {
        alert("Error");
        $("#"+id+"Loading").hide();
        $("#"+id).show();
      }

      console.log(url);
    },
    error: function (msg) {
      console.log(msg);

      alert("Error");

      $("#"+id+"Loading").hide();
      $("#"+id).show();
    }
  });
}

$('#btn_active').addClass('disabled');
$('#btn_active').prop('disabled', true)

$(document).on('click', '#checkTerms', (evt) => {
  console.log(evt.target.checked);

  if ( evt.target.checked ) {
    $('#btn_active').removeClass('disabled');
    $('#btn_active').prop('disabled', false)
  }
  else {
    $('#btn_active').addClass('disabled');
    $('#btn_active').prop('disabled', true)
  }
});


function addAttriCart(attributes){

const url = '/cart/update.js';
let attributesObj = {};
  attributes.forEach(attribute => {
      attributesObj[attribute.name] = attribute.value;
  });
const data = {
      attributes: attributesObj, 
  };

fetch(url, {
method: 'POST',
headers: {
'Content-Type': 'application/json',
},
body: JSON.stringify(data),
})
.then(response => response.json())
.then(result => {
console.log('Nota agregada con éxito:', result);     
})
.catch(error => {
console.error('Error al agregar la nota:', error);
});


}

